import { createSelector } from '@reduxjs/toolkit';

import { selectAppliedADUAdjsDisplay } from './selectADUAdj.ts';
import { selectAppliedAtticAdjsDisplay } from './selectAtticAdjustment.ts';
import { selectAppliedBarnAdjsDisplay } from './selectBarnAdj.ts';
import { selectAppliedFireplaceAdjsDisplay } from './selectFireplaceAdjustment.ts';
import { selectAppliedGarageCarportAdjsDisplay } from './selectGarageCarportAdj.ts';
import { selectAppliedManualCostAdjsDisplay } from './selectManualCostAdj.ts';
import { selectAppliedPoolSpaAdjsDisplay } from './selectPoolSpaAdj.ts';
import { selectAppliedPorchPatioDeckAdjsDisplay } from './selectPorchPatioDeckAdj.ts';
import { selectAppliedShedAdjsDisplay } from './selectShedAdj.ts';
import { selectAppliedWorkshopAdjsDisplay } from './selectWorkshopAdj.ts';

export const selectAppliedAdditionStructureAdjsDisplay = createSelector(
  [
    selectAppliedADUAdjsDisplay,
    selectAppliedAtticAdjsDisplay,
    selectAppliedBarnAdjsDisplay,
    selectAppliedFireplaceAdjsDisplay,
    selectAppliedGarageCarportAdjsDisplay,
    selectAppliedManualCostAdjsDisplay,
    selectAppliedPoolSpaAdjsDisplay,
    selectAppliedPorchPatioDeckAdjsDisplay,
    selectAppliedShedAdjsDisplay,
    selectAppliedWorkshopAdjsDisplay,
  ],
  (
    adu,
    attic,
    barn,
    fireplace,
    garageCarport,
    manualCost,
    poolSpa,
    porchPatioDeck,
    shed,
    workshop,
  ) => ({
    adu,
    attic,
    barn,
    fireplace,
    garageCarport,
    manualCost,
    poolSpa,
    porchPatioDeck,
    shed,
    workshop,
  }),
);
